module.exports = __webpack_public_path__ + "static/media/42-8.6f97133e.mp3";